import { useContext } from 'react';
import InputConfig from '../../../../Components/InputConfig';
import { Grid } from '@mui/material';
import useStyles from './styles';
import Paper from '@mui/material/Paper';
import { FvpConfigContext } from '../../../../Contexts/FvpConfigContext';
import { ACCESS_CONTROL_CONSTANTS } from '../../../../core/constants';
import PageHeading from '../../../../Components/PageHeading';
import useCommonStyles from '../../../../commonStyles';
const { SYSTEMS } = ACCESS_CONTROL_CONSTANTS;

const BatchedAdRequestsConfig = ({ keyData }) => {
	const classes = useStyles();
	const { rawConfig, updateRawConfig } = useContext(FvpConfigContext);
	const commonStyleClasses = useCommonStyles();
	return (
		<Paper className={commonStyleClasses.mainPagePaperMarginStyle}>
			<PageHeading
				headingName="Batched Ad Requests"
				headingPath={['Dashboard', 'Fvp', 'Request Structure Data', 'Batched Ad Requests']}
				description="Manage Request Batch configurations here."
			/>
			<Grid
				container
				spacing={1}
				style={{ height: '60%', width: '90%', marginLeft: '4rem', marginTop: '3rem' }}
			>
				<Grid item xs={3}>
					<InputConfig
						system={SYSTEMS.FVP_PLAYER}
						label="Request Batch Size"
						keyData={keyData + `.requestBatchSize`}
						inputType="number"
						object={rawConfig}
						updateObject={updateRawConfig}
					/>
				</Grid>
				<Grid item xs={3}>
					<InputConfig
						system={SYSTEMS.FVP_PLAYER}
						label="Max Number of Batches"
						keyData={keyData + '.maxNumberOfBatches'}
						inputType="number"
						object={rawConfig}
						updateObject={updateRawConfig}
					/>
				</Grid>
				<Grid item xs={3}>
					<InputConfig
						system={SYSTEMS.FVP_PLAYER}
						label="Filled Retry Interval"
						keyData={keyData + '.filledRetryInterval'}
						inputType="number"
						object={rawConfig}
						updateObject={updateRawConfig}
					/>
				</Grid>
				<Grid item xs={3}>
					<InputConfig
						system={SYSTEMS.FVP_PLAYER}
						label="Unfilled Retry Interval"
						keyData={keyData + '.unfilledRetryInterval'}
						inputType="number"
						object={rawConfig}
						updateObject={updateRawConfig}
					/>
				</Grid>
			</Grid>
		</Paper>
	);
};
export default BatchedAdRequestsConfig;
